function orderedMatch(text, substr) {
  let from = 0;
  text = text.toLowerCase();
  substr = substr.toLowerCase();
  while (substr.length) {
    from = text.indexOf(substr[0], from);
    if (from === -1) {
      return false;
    }
    substr = substr.slice(1);
    from++;
  }
  return true;
}

export { orderedMatch };
